import React from 'react';
import { compose } from 'redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import reduxConnectContainer from './MyComments.container';
import EmptyState from '../../EmptyState';
import { default as MyComments, Props as WidgetProps } from './MyComments';
import WidgetBoxWide, {
  Props as WidgetBoxWideProps,
} from '../_partials/WidgetBoxWide';
import { URLS } from '@wix/da-url';

import s from './MyComments.scss';

const enhance = compose(
  reduxConnectContainer,
  withTranslation()
);

class MyCommentsInExpandedWidgetContainer extends React.Component<
  WidgetProps &
    WidgetBoxWideProps &
    WithTranslation & {
      hasMoreBadgeActivity: boolean;
      fetchMoreBadgeActivity: () => void;
      isFetchingBadgeActivity: boolean;
      isOwner: boolean;
      totalSent: number;
    }
> {
  render() {
    const {
      id,
      subHeader,
      totalSent,
      headerExtraElementsOnMobile,
      isHeaderStickyOnMobile,
      hasMoreBadgeActivity,
      fetchMoreBadgeActivity,
      isFetchingBadgeActivity,
      widgetMoveUp,
      widgetMoveDown,
      widgetRemove,
      widgetBoxClassName,
      parentRef,
      isEmpty,
      section,
      zone,
      ...props
    } = this.props;

    return (
      <WidgetBoxWide
        section={section}
        zone={zone}
        id={id}
        header={props.t!('widgets.myComments.header')}
        count={totalSent}
        isHeaderStickyOnMobile={isHeaderStickyOnMobile}
        headerExtraElementsOnMobile={headerExtraElementsOnMobile}
        hasMore={hasMoreBadgeActivity}
        fetchMore={fetchMoreBadgeActivity}
        isFetching={isFetchingBadgeActivity}
        moduleId={props.moduleId}
        widgetMoveUp={widgetMoveUp}
        widgetMoveDown={widgetMoveDown}
        widgetRemove={widgetRemove}
        className={widgetBoxClassName}
        parentRef={parentRef}
        isEmpty={isEmpty}
        emptyView={
          props.isOwner ? (
            <EmptyState
              view="small"
              className={s['empty-state']}
              title={props.t!('widgets.myComments.empty.title.owner')}
              subtitle={props.t!('widgets.myComments.empty.subtitle.owner')}
              withButton
              buttonLabel={props.t!('widgets.myComments.empty.CTALabel.owner')}
              onButtonClick={this.navigateToBrowse}
            />
          ) : (
            <EmptyState
              view="small"
              className={s['empty-state']}
              title={props.t!('widgets.myComments.empty.title.visitor', {
                username: props.profileOwnerUser.username,
              })}
              subtitle={props.t!('widgets.myComments.empty.subtitle.visitor', {
                username: props.profileOwnerUser.username,
              })}
            />
          )
        }
      >
        <MyComments {...props} />
      </WidgetBoxWide>
    );
  }

  navigateToBrowse() {
    window.location.replace(URLS.ROOT);
  }
}

export default enhance(
  MyCommentsInExpandedWidgetContainer
) as React.ComponentType<
  Pick<
    WidgetBoxWideProps,
    | 'moduleId'
    | 'id'
    | 'isHeaderStickyOnMobile'
    | 'subHeader'
    | 'headerExtraElementsOnMobile'
  >
>;
